
<template lang="pug">
  a.button.button--icon(
    :class="buttonClass",
    :disabled="isDisabled",
    :href="href",
    :title="label",
    :target="target"
  )
    icon(v-if="icon", :name="icon", :height="height" :width="width")
    span.u-sr-only {{ label }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue'
  import IconButton from 'scripts/components/buttons/IconButton.vue'

  export default {
    extends: IconButton,
    name: 'IconLink',
    components: { Icon },
    props: {
      href: {
        type: String,
        default: '#'
      },
      external: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      target () {
        return (this.external) ? '_blank' : '_self'
      }
    }
  }
</script>

<style scoped lang="scss">
  .button--icon {
    &[disabled] {
      pointer-events: none;
      opacity: 0.4;
    }
  }
</style>
